module.exports = __webpack_public_path__ + "img/currencyBack1.3910a34a.png";